import "core-js/fn/object";
import "./login"


// WEBPACK FOOTER //
// ./src/modulos/login/index.ts